/**
 * Клиент к BFF. Токена здесь нет и быть не может — он живёт в серверной сессии, браузер носит
 * только cookie. Поэтому все запросы идут с credentials и относительными путями.
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly fieldErrors?: Array<{ field: string; message: string }>,
  ) {
    super(message);
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api/tracker${path}`, {
    method,
    credentials: 'same-origin',
    headers: body === undefined ? {} : { 'content-type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (res.status === 401) {
    // Сессия кончилась — уводим на вход и запоминаем, куда возвращаться.
    window.location.href = `/auth/login?returnTo=${encodeURIComponent(window.location.pathname)}`;
    throw new ApiError(401, 'Требуется вход');
  }

  const text = await res.text();
  const payload = text ? JSON.parse(text) : null;

  if (!res.ok) {
    const message = payload?.message ?? `Ошибка ${res.status}`;
    throw new ApiError(res.status, message, payload?.fieldErrors ?? undefined);
  }
  return payload as T;
}

export const api = {
  get: <T,>(path: string) => request<T>('GET', path),
  post: <T,>(path: string, body?: unknown) => request<T>('POST', path, body ?? {}),
  put: <T,>(path: string, body: unknown) => request<T>('PUT', path, body),
  patch: <T,>(path: string, body: unknown) => request<T>('PATCH', path, body),
  del: <T,>(path: string) => request<T>('DELETE', path),
};

/** Кто вошёл. Отдельный маршрут BFF, не через прокси: сессия — его собственные данные. */
export async function fetchSession(): Promise<{ id: string; name?: string } | null> {
  const res = await fetch('/auth/me', { credentials: 'same-origin' });
  return res.ok ? ((await res.json()) as { id: string; name?: string }) : null;
}